<div class="container-fluid"
  [class.container]="!user"
>
  <div class="row">
    <app-sidebar class="col-lg-2 d-none d-lg-block bg-light sidebar" *ngIf="user"></app-sidebar>

    <main role="main" class="col-12 ml-sm-auto p-4"
      [ngClass]="{'col-lg-10': user}"
    >
      <div [ngClass]="{'mx-2 mx-md-5 my-5 p-3 p-md-5 card': !user}">
        <router-outlet></router-outlet>
      </div>

      <div class="loading-container pt-5" [hidden]="!loading">
        <div class="text-center">
          <fa-icon icon="spinner" [pulse]="true" size="lg"></fa-icon>
        </div>
      </div>
    </main>
  </div>
</div>

<app-toast></app-toast>
